<template>
<div>
  <div v-if="!p_isDisabled" @click="executeMenuItemButton" v-bind:id="p_customId" class="configurator-menu-item" v-bind:class="p_customClass">
      <span class="configurator-menu-item-label">
          <i v-if="p_icon" v-bind:class="p_icon" class="configurator-menu-item-icon"></i>
          <span v-html="p_label"> </span>
      </span>
  </div>
  <div v-if="p_isDisabled" @click="executeDisabledMenuItemButton" v-bind:id="p_customId" class="configurator-menu-item" v-bind:class="p_customClass">
      <span class="configurator-menu-item-label">
          <i v-if="p_icon" v-bind:class="p_icon" class="configurator-menu-item-icon"></i>
          <span v-html="p_label"> </span>
      </span>
  </div>
</div>
</template>

<script>

export default {
  props: {
    p_label: String,
    p_isDisabled: {
      default: false,
      type: Boolean,
    },
    p_icon: {
      default: null,
      type: String,
    },
    p_customClass: {
      default: null,
      type: String,
    },
    p_customId: {
      default: null,
      type: String,
    },
  },
  methods: {
    executeMenuItemButton() {
      this.$parent.executeMenuItemButton(this.p_label);
    },
    executeDisabledMenuItemButton() {
      this.$parent.executeDisabledMenuItemButton(this.p_label);
    },
  },
};
</script>

<style language="css">
  @import '../../scss/menu_item/style.css';
</style>



// WEBPACK FOOTER //
// src/components/configurator/MenuItem.vue